import { render } from "./heroFaqBlock.vue?vue&type=template&id=759647d5&scoped=true&ts=true"
import script from "./heroFaqBlock.vue?vue&type=script&lang=ts"
export * from "./heroFaqBlock.vue?vue&type=script&lang=ts"

import "./heroFaqBlock.vue?vue&type=style&index=0&id=759647d5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759647d5"]])

export default __exports__